export type StatID = { StatID?: number }

export type AlarmProps = AlarmComparisonProps & StatID

export type AlarmComparisonProps = {
    AlarmComparisonType: number
    AlarmComparisonValue1: string
    AlarmComparisonValue2: string
    AlarmType: number
    AlarmRepeatType?: number
}

export type StatProps = AlarmComparisonProps & {
    StatID: number
    Category: number
    UnitType: number
    StatFlagsType: number
    IsActiveRTStat: boolean
    SupportsImages: boolean
    IsTitleDisplayed: boolean
    DisplayedAs: number
    ColourTxt: number
    ColourBG: number
    AlarmType: number
    IsGraphDialFacadeReversed: boolean
    IsGraphDialAxisReversed: boolean
    UserContentFilePath: string | null
    UserContentFitTile: boolean
    ShortName: string
    MediumName: string
    LongName: string
}

export type AvailableStatisticsFieldsArray = StatProps[]

export type StatisticsConfiguration = {
    ID: number
    mediumName: string
    shortName: string
    unitType: number
    statFlagsType: number
    isTitleDisplayed: boolean
    displayedAs: number
    colourText: number
    colourBackground: number
    alarmType: number
    alarmSoundType: number
    alarmRepeatType: number
    alarmSettingsValue: number
    alarmComparisonType: number
    alarmComparisonValue1: string
    alarmComparisonValue2: string
    graphDialScaleMaxDefault: string
    isGraphDialFacadeReversed: boolean
    isGraphDialAxisReversed: boolean
    userContentFilePath: string
    userContentFitTile: boolean
    ordering: number
    customName: string
    customWidth: number
}

export enum TileDisplayedAsGraphDialValues {
    TILE_DISPLAYED_AS_GRAPH_DIAL_PROGRESS_RING = 0,
    TILE_DISPLAYED_AS_GRAPH_DIAL_PROGRESS_RING_2 = 10,
    TILE_DISPLAYED_AS_GRAPH_DIAL_GRADATED_DIAL = 50,
    TILE_DISPLAYED_AS_GRAPH_DIAL_GRADATED_DIAL_2 = 100,
    TILE_DISPLAYED_AS_GRAPH_DIAL_GLIDE_SLOPE = 150,
    TILE_DISPLAYED_AS_GRAPH_DIAL_GLIDE_SLOPE_2 = 200,
    TILE_DISPLAYED_AS_GRAPH_DIAL_BULLSEYE = 250,
    TILE_DISPLAYED_AS_GRAPH_DIAL_BARGAUGE = 251,
    TILE_DISPLAYED_AS_GRAPH_DIAL_CONEGAUGE = 252
}

export enum TileDisplayAsValues {
    SIMPLE_TEXT_VALUE = -1,
    PROGRESS_RING = 0,
    GRADATED_DIAL = 50,
    GLIDE_SLOPE = 150,
    BULLSEYE = 250,
    BAR_GAUGE = 251,
    CONE_GAUGE = 252,
    DASHBOARD_SPEEDOMETER_BLACK = 1000,
    DASHBOARD_SPEEDOMETER_AMBER = 1010,
    DASHBOARD_TEMPERATURE_GAUGE = 1050,
    DASHBOARD_FUEL_GAUGE = 1100,
    DASHBOARD_POWER_GAUGE = 1150,
    DASHBOARD_COLOUR_GAUGE = 1200
}
